import { Map as MaplibreMap, Marker as MaplibreMarker, NavigationControl } from "maplibre-gl";
import { OSM_SATELLITE_STYLE, OSM_STREET_STYLE } from "./styles";
// Parts of the API used unchanged by the app.
export { GeolocateControl, LngLatBounds, NavigationControl, Popup } from "maplibre-gl";
export { OSM_SATELLITE_STYLE, OSM_STREET_STYLE } from "./styles";
const isFlatBounds = (b) => Array.isArray(b) && b.length === 4 && b.every(n => typeof n === "number");
// nmaps-gl [west, north, east, south] -> MapLibre [west, south, east, north].
const reorderBounds = (b) => [b[0], b[3], b[2], b[1]];
const CORNERS = ["top-left", "top-right", "bottom-left", "bottom-right"];
const normalizePosition = (p) => CORNERS.includes(p) ? p : "top-right";
export class Map extends MaplibreMap {
    constructor(options) {
        const { rightClick: _rightClick, bounds, style, ...rest } = options;
        super({
            ...rest,
            style: style ?? OSM_STREET_STYLE,
            bounds: isFlatBounds(bounds) ? reorderBounds(bounds) : bounds,
        });
    }
    addControl(control, position) {
        super.addControl(control, normalizePosition(position));
        return this;
    }
    fitBounds(bounds, options) {
        super.fitBounds(isFlatBounds(bounds) ? reorderBounds(bounds) : bounds, options);
        return this;
    }
}
export class Marker extends MaplibreMarker {
    constructor(elementOrOptions) {
        super(elementOrOptions instanceof HTMLElement ? { element: elementOrOptions } : elementOrOptions);
    }
}
// MapLibre folds rotation into NavigationControl; expose a compass-only one.
export class RotateControl extends NavigationControl {
    constructor() {
        super({ showCompass: true, showZoom: false, visualizePitch: false });
    }
}
// nmaps-gl was also imported as a default export holding global config. Kept
// writable for source compatibility; MapLibre needs no global access token.
const nmapsgl = {
    accessToken: "",
    baseApiUrl: "",
    SATELLITE_STYLE: OSM_SATELLITE_STYLE,
    STREET_STYLE: OSM_STREET_STYLE,
    Map,
    Marker,
    RotateControl,
};
export default nmapsgl;
